import {PROJECT_COMMITS as COMMITS, PROJECT_DISPATCHS as DISPATCHS} from '@/store/contracts'
import {save, create, addNode,removeNode,moveNode, load, defaultValue, setting, reviewProjects} from '@/api/project'
import {setProperty} from '@/utils/Reflection'
import Tree from '../utils/Tree'

const STATUS={
    clean:'clean',
    new:'new',
    ready:'ready',
    persistenting: 'persistenting',
    persistent: 'persistent',
    edit: 'edit',
}
const state={
    topProjectId: null,
    newProject: null,
    projectTree: new Tree(),
    status:STATUS.clean
}
const getters={
    topProject(state){
        
        return state.projectTree.top||state.newProject
    },
    topProjectId(state){
        if(state.projectTree.top){
            return state.projectTree.top._id
        }
    },
    isNew(state){
        return !state.projectTree.top
    },
    isPersistented(state){
        return state.status===STATUS.persistent
    },
    isPersistenting(state){
        return state.status===STATUS.persistenting
    },
    hasChangedData(state){
        
        if(state.newProject && state.status===STATUS.edit){
            return true
        }else{
            return state.projectTree.getChanged().length>0
        }
    }

}

function _setStatus(value){
    state.status = value
}

const mutations={

    //初始化当前项目，将传入项目作为当前操作对象
    [COMMITS.NEW] (state, defaultValues){
        
        if(state.status!==STATUS.clean){
            throw(`当前状态不允许新建：${state.status},请先调用CLEAN清除状态`)
        }
        if(defaultValues && defaultValues._id){
            defaultValues = {...defaultValues}
            delete defaultValues._id
        }
        state.newProject=(defaultValues||{});
        _setStatus(STATUS.new)
    },
    [COMMITS.TOP_PROJECT_ID](state, topProjectId){
        if(state.status!==STATUS.clean){
            throw(`当前状态不允许设置TOP_PROJECT_ID：${state.status},请先调用CLEAN清除状态`)
        }
        if(!topProjectId){
            throw(`id不能为空`)
        }
        if(state.topProjectId){
            throw(`已经打开项目:${topProjectId}`)
        }
        state.topProjectId = topProjectId
        _setStatus(STATUS.ready)
    },
    [COMMITS.CLEAN](state, options){
        const {force} = options||{}
        if(!force && getters.hasChangedData(state)){
            throw(`当前有未保存的数据，不允许CLEAN.(未提供force参数)`)
        }
        
        Object.assign(state, {
            topProjectId: null,
            newProject: null,
            projectTree: new Tree(),
            status:STATUS.clean
        })
    },
    // 编辑字段
    [COMMITS.EDIT] (state, {value, propertyChain, id}){
        
        //TODO 处理数据版本问题
        if(!id){
            id = value?value._id:null
        }
        
        let edited = false;
        if(!id){
            if(propertyChain){
                edited = setProperty(state.newProject, propertyChain, value)
            }else{
                if(!value){
                    throw('不能设置project为'+value)
                }
                state.newProject=value
                edited = true
            }
            
        }else{            
            edited = state.projectTree.modify(id, value, propertyChain)
        }
        if(edited){
            _setStatus(STATUS.edit)
        }
        
    },

    //保存项目
    [COMMITS.PERSISTENT] (state, {tree, data, merge}){           
        _setStatus(STATUS.persistenting)
        state.newProject=null
        if(tree) state.topProjectId = tree._id
        state.projectTree.buildTree({tree, data, merge})
        
        _setStatus(STATUS.persistent)
    },

    //保存项目
    [COMMITS.SET_REVIEW] (state, {pass}){   
        const topProject = state.projectTree?.top
        if(topProject){
            topProject._ext.reviewed = pass
        }        
    },
}
function isNew(project){
    return !project._id
}
async function loadTopProject({ commit, state }){
    const {projectTree, projectInfos} = await load(state.topProjectId).then((r)=>r.data)
    commit(COMMITS.PERSISTENT,  {tree: projectTree, data:projectInfos})
}
const actions={
    //新建项目
    async [DISPATCHS.NEW] ({ commit, state }) {
        
        //TODO 检查之前的项目是否有未处理的状态
        
        //获取默认值        
        const defaultValues = await defaultValue().then(r=>r.data) 
        commit(COMMITS.NEW, defaultValues)        
        return state.newProject
    },
    //打开项目
    async [DISPATCHS.OPEN] ({ commit, state },{topProjectId, loadNow=true}) {
        if(!topProjectId){
            throw('topProjectId不能为空！')
        }
        if(state.topProjectId!==topProjectId){
            commit(COMMITS.TOP_PROJECT_ID, topProjectId)
        }        
        if(loadNow){
            return await loadTopProject({ commit, state })
        }
    },
    //关闭项目
    [DISPATCHS.CLOSE] ({ commit, state }, options) {
        //TODO 检查是否有未保存的
        commit(COMMITS.CLEAN, options)
    },
    //加载项目
    async [DISPATCHS.LOAD] ({ commit, state }) {        
        if(!state.topProjectId){
            throw(`请先打开项目`)
        }
        await loadTopProject({ commit, state })
         
    },
    //保存项目
    async [DISPATCHS.SAVE] ({ commit, state }) {
        
        if(state.newProject){
            const {projectTree, projectInfos} = await createNewToServer(state.newProject)
            commit(COMMITS.PERSISTENT, {tree: projectTree, data:projectInfos})
  
        }else{
            const changedProjects = state.projectTree.getChanged()
            if(changedProjects && changedProjects.length){
                const r = await saveChangedToServer(changedProjects)
                if(r){
                   commit(COMMITS.PERSISTENT,  {tree: r.projectTree, data:r.projectInfos, merge: true}) 
                }                
            }
            
        }
            
        
        
    },
    //加载项目
    async [DISPATCHS.LOAD_PROJECT] ({ commit, state }, {projectId}) {
        if(state.projectTree && projectId){                
            if(!state.projectTree.top?._id){
                throw('未初始化总项目')
            }
            let proj = state.projectTree.find(projectId)
            // if(!proj){
            //     proj = await load(projectId).then(r=>r.data)
            //     if(proj){
            //         commit(COMMITS.PERSISTENT,  { data:[proj], merge: true}) 
            //     }
            // }
            return proj
        }

    },
    //移除项目
    //新增项目节点
    async [DISPATCHS.ADD_NODE] ({ commit, state }, {parentId,type}) {
        //在服务端添加节点
        const {projectTree, projectInfos} = await addNode({parentId,type}).then(r=>r.data)
        commit(COMMITS.PERSISTENT,  {tree: projectTree, data:projectInfos, merge: true})
        return projectInfos
    },
    //删除项目节点
    async [DISPATCHS.REMOVE_NODE] ({ commit, state }, {projectId}) {
        //先保存全部
        const changedProjects = state.projectTree.getChanged()
        if(changedProjects && changedProjects.length){
            await saveChangedToServer(changedProjects)
        }
        //在服务端删除节点
        const {projectTree, projectInfos} = await removeNode(projectId).then(r=>r.data)
        
        //全部重新加载
        commit(COMMITS.PERSISTENT,  {tree: projectTree, data:projectInfos, merge: false})
        return projectInfos
    },
    //移动项目节点
    async [DISPATCHS.MOVE_NODE]({ commit, state }, {sourceProjectId, targetProjectId, position}) {        
        if(!sourceProjectId || !targetProjectId || !position){
            throw(`移动节点的参数不能为空:sourceProjectId:${sourceProjectId},targetProjectId:${targetProjectId}, position:${position}`);
        }
        //在服务端移动节点
        const projectTree = await moveNode({sourceProjectId, targetProjectId, position}).then(r=>r.data)
        
        //全部重新加载
        commit(COMMITS.PERSISTENT,  {tree: projectTree})
        return projectTree
    },
    //项目设置
    async [DISPATCHS.SETTING] ({ commit, state }, {projectId,settings}) {
        await setting({projectId,settings})
    },
    //入库
    async [DISPATCHS.REVIEW] ({ commit, state }, {pass}) {
        await reviewProjects( [state.topProjectId], pass)
        //设置入库状态值
        commit(COMMITS.SET_REVIEW,  {pass})
    },
}


async function getProjectDefaultValues(options){
    let type
    if(options){
        type = options.type
    }
    if(!type){
        type = '项目工程'
    }
    return Promise.resolve({
        '项目类型': type,
        '项目名称': type
    })
}
async function createNewToServer(newProject){
    if(newProject){
        const r =  await create(newProject);
        return r.data;
    }
}
async function saveChangedToServer(changedProjects){
    const r = await save(changedProjects)
    return r.data
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}